// extracted by mini-css-extract-plugin
export default {"screen":"screen__88bb319b","button":"button__65cc3800","primary":"primary__ab64c91c","default":"default__fd2f65a7"};